import React from 'react'
import {toggle} from 'opticks'

import {FontsLoader as FontsLoaderExperimental} from '../../experimental/FontsLoader'
import {FontsLoader as FontsLoaderCurrent, PropsType} from './FontsLoader'

const FontsLoader = (props: PropsType) =>
  toggle(
    '319d377e-non-latin-fonts',
    <FontsLoaderCurrent {...props} />,
    <FontsLoaderExperimental {...props} />
  )

export default FontsLoader
